<template>
    <div class="container">
        <div class="action-panel left">
            <router-link tag="div" class="btn" v-for="(app, index) in apps" :key="index" :to="'/apps/'+app.path">
                {{app.name}}
            </router-link>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        display: flex;
        flex-direction: column;
    }
</style>
<script>

export default {
    name:'AppOverview',
    data() {
        return {
            apps: [
                {
                    name: 'Vouchers',
                    path: 'vochers',
                },
                {
                    name: 'Minecraft Searcher [IN DEVELOPMENT]',
                    path: 'mcsearch',
                }
            ]
        }
    },
}
</script>